<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="toc"><span class="epub-b">Contents</span></p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc"><a href="#/xhtml/dedication#ded">Dedication</a></p>
<p class="toc-bot"><a href="#/xhtml/foreword#fore">Foreword</a></p>
<p class="toc-bot"><a href="#/xhtml/part1#pt1"><span class="epub-sc">WHAT THE TWILIGHT SAYS: AN OVERTURE</span></a></p>
<p class="toc"><span href="#/xhtml/chapter1#ch1" title="Link target outside of Sample"><span class="epub-i">The Sea at Dauphin</span></span></p>
<p class="toc"><span href="#/xhtml/chapter2#ch2" title="Link target outside of Sample"><span class="epub-i">Ti-Jean and His Brothers</span></span></p>
<p class="toc"><span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample"><span class="epub-i">Malcochon, or The Six in the Rain</span></span></p>
<p class="toc"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample"><span class="epub-i">Dream on Monkey Mountain</span></span></p>
<p class="toc-bot"><span href="#/xhtml/epilogue#epi" title="Link target outside of Sample"><span class="epub-i">Epilogue</span></span></p>
<p class="toc"><span href="#/xhtml/adcard#ad" title="Link target outside of Sample">Also by Derek Walcott</span></p>
<p class="toc"><span href="#/xhtml/abouttheauthor#au" title="Link target outside of Sample">About the Author</span></p>
<p class="toc"><span href="#/xhtml/copyright#crt" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6e0458e6